export const CUSTOM_PROFILE = 'Custom profile';
